import LifeStyleBanner from './LifeStyleBanner.component';

export default LifeStyleBanner;